import api from "./index";
import esupplyvetApi from "./esupplyvet";
import AuthService from "@/services/authService";

/**
 * Récupère les pages éditoriales (articles) selon le channel de l'utilisateur
 * @returns {Promise} Réponse de l'API avec les articles
 */
export const getPageEditoriales = async () => {
  try {
    const channel = AuthService.getUserChannel();

    const apiInstance = channel === "esupplyvet" ? esupplyvetApi : api;

    const response = await apiInstance.get("/page-editoriales");

    const articles = Array.isArray(response.data) ? response.data : [];
    const filteredArticles = articles.filter(article => article.channel && article.channel.code === channel);

    return filteredArticles;
  } catch (error) {
    console.error("Erreur lors de la récupération des articles:", error);
    throw error;
  }
};

/**
 * Récupère un article spécifique par son ID
 * @param {string|number} id - ID de l'article
 * @returns {Promise} Réponse de l'API avec l'article
 */
export const getPageEditoriale = async id => {
  try {
    const channel = AuthService.getUserChannel();

    const apiInstance = channel === "esupplyvet" ? esupplyvetApi : api;

    const response = await apiInstance.get(`/page-editoriales/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération de l'article:", error);
    throw error;
  }
};
